import Sentry from './sentry'

/**
 * Manually capture errors and send to Sentry
 *
 * @param  {...any} args The error to capture
 * @see [Capturing Errors](https://docs.sentry.io/platforms/javascript/#capturing-errors)
 */
export const exception = (...args) => Sentry.captureException(...args)

/**
 * Typically, the Sentry SDK does not emit messages. This is most useful when
 * you’ve overridden fingerprinting but need to give a useful message.
 *
 * @param  {String} msg The message to send
 * @param  {String} [level] One of 'fatal', 'error', 'warning', 'log', 'info, 'debug', 'critical'
 * @see [Capturing Messagers](https://docs.sentry.io/error-reporting/capturing/?platform=browsernpm#capturing-messages)
 */
export const message = (msg, level) => Sentry.captureMessage(msg, level)

/**
 * Sets user context for an error. Requires at least one of the following values
 * to be present: `id`, `username`, `email`, `ip_address`.
 *
 * @param  {Object} properties An object of user properties
 * @see  [Capturing The User](https://docs.sentry.io/platforms/javascript/#capturing-the-user)
 */
export const setUser = (properties = {}) => Sentry.setUser({...properties})

/**
 * Send arbitrary key/value pairs of data to Sentry alongside an event
 *
 * @param  {String} key The key to associate the value with
 * @param  {any} value The data you wish to associate with the key
 * @see [Extra Context](https://docs.sentry.io/platforms/javascript/#extra-context)
 */
export const setExtra = (key, value) => Sentry.setExtra(key, value)
